import {
  Flex,
  Typography,
  IconRankUp,
  IconRankDown,
  IconRankStay,
} from '@banhala/ui-kit';
import React from 'react';
import { SearchType } from 'shared/src/api/enums';
import { useAtomValue } from 'jotai';
import { searchHelperFilterAtom } from '../../states/searchHelperFilter.atom';
import { useLogSearchKeyword } from '../../hook/useLogSearchKeyword';
import { Accessibility } from '../../../../utils/accessibility';

export interface KeywordItem {
  sno?: number;
  name?: string;
  query?: string;
  rank: number;
  rank_state: string;
  age_range: number;
}

type Props = {
  keywords: KeywordItem[];
  onPress: (keyword: KeywordItem) => void;
};

export const PopularKeywordList = ({ keywords, onPress }: Props) => {
  const filter = useAtomValue(searchHelperFilterAtom);
  const selectedAgeName =
    filter.ageFilters.find(f => f.value === filter.selectedAge)?.name ?? '';
  const logSearchKeyword = useLogSearchKeyword();

  const getRankIcon = (rankState: string) => {
    switch (rankState) {
      case 'UP':
        return <IconRankUp width={12} height={12} fill={'red'} />;
      case 'DOWN':
        return <IconRankDown width={12} height={12} fill={'blue'} />;
      case 'STAY':
        return <IconRankStay width={12} height={6} fill={'gray'} />;
    }
  };

  return (
    <Flex padding={{ horizontal: 16, vertical: 8 }}>
      {keywords.map((keyword, index) => (
        <Flex.Row
          key={keyword.sno ?? keyword.rank}
          testID={Accessibility.Search.popularKeywordListItem(keyword.query ?? '', index)}
          alignItems="center"
          justifyContent="space-between"
          height={44}
          onPress={() => {
            logSearchKeyword({
              searchType: SearchType.POPULAR,
              keyword: keyword.query ?? '',
              clickIndex: index,
              ageGroup: selectedAgeName,
            });
            onPress(keyword);
          }}
        >
          <Flex.Row gap={12} alignItems="center">
            <Typography type="subtitle1" maxWidth={24}>
              {keyword.rank}
            </Typography>
            <Typography type="body1">{keyword.query ?? ''}</Typography>
          </Flex.Row>
          {getRankIcon(keyword.rank_state)}
        </Flex.Row>
      ))}
    </Flex>
  );
};
